import Vue from 'vue'
// 公用的删除方法
Vue.prototype.delete = function (url, postData) {
  this.$http.delete(url, postData)
    .then(res => {
      if (res.msg) {
        this.$message({
          message: res.msg,
          type: 'warning'
        });
      } else{
        this.$message({
          message: '删除成功',
          type: 'success'
        });
        this.$refs.child.handlePageSizeChange()
      }         
    })
    .catch(err => {
      console.log(err)
    })
} 

// 公用的修改方法
Vue.prototype.put = function (url, postData) {
  this.$http.put(url, postData)
    .then(res => {
      if (res.msg) {
        this.$message({
          message: res.msg,
          type: 'warning'
        });
      } else{
        this.$message({
          message: '修改成功',
          type: 'success'
        });
        this.$refs.child.handlePageSizeChange()
        this.addVisible = false
      }         
    })
    .catch(err => {
      console.log(err)
    })
} 

// 公用的添加方法
Vue.prototype.post = function (url, postData) {
  this.$http.post(url, postData)
  .then(res => {
    if (res.msg) {
      this.$message({
        message: res.msg,
        type: 'warning'
      });
    } else {
      this.$message({
        message: '添加成功',
        type: 'success'
      });
      this.$refs.child.handlePageSizeChange()
      this.addVisible = false
    }            
  })
  .catch(err => {
    console.log(err)
  })
} 

// 公用的查看方法
Vue.prototype.get = function (url, postData) {
  this.$http.get(url, postData)
  .then(res => {
    console.log(res)
    if (res.msg) {
      this.$message({
        message: res.msg,
        type: 'warning'
      });
    } else {
      this.addForm = res
    }            
  })
  .catch(err => {
    console.log(err)
  })
} 
// 公用多个删除方法
Vue.prototype.postDelete = function (url, postData) {
  this.$http.post(url, postData)
    .then(res => {
      if (res.msg) {
        this.$message({
          message: res.msg,
          type: 'warning'
        });
      } else{
        this.$message({
          message: '删除成功',
          type: 'success'
        });
        this.$refs.child.handlePageSizeChange()
      }         
    })
    .catch(err => {
      console.log(err)
    })
} 


// WEBPACK FOOTER //
// ./src/api/common.js